import React, { useMemo, useRef, useState } from "react";
import { MapContainer, Marker, TileLayer } from 'react-leaflet'
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { CEMENTERY_LAT, CEMENTERY_LNG, MAP_ZOOM } from "../config/defaultValues.js";


function CoordinatesMap(props) {
  const { lat, lng, handleApplyMapCoordinates, isMarkerDraggable, style } = props;
  const center = {
    lat: lat || CEMENTERY_LAT,
    lng: lng || CEMENTERY_LNG,
  }

  function DraggableMarker(props) {
    const { handleApplyMapCoordinates } = props;
    const [position, setPosition] = useState(center)
    const markerRef = useRef(null)

    L.Marker.prototype.options.icon = L.icon({
      iconUrl: icon,
      shadowUrl: iconShadow
    })

    const eventHandlers = useMemo(
      () => ({
        dragend() {

          const marker = markerRef.current
          if (marker != null) {
            setPosition(marker.getLatLng());
            handleApplyMapCoordinates(marker.getLatLng());
          }
        },
      }),
      [handleApplyMapCoordinates],
    )

    return (
      <Marker
        draggable={isMarkerDraggable}
        eventHandlers={eventHandlers}
        position={position}
        ref={markerRef}>
      </Marker>
    )
  }

  return (
      <MapContainer
        center={center}
        zoom={MAP_ZOOM}
        scrollWheelZoom={true}
        style={style}

      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <TileLayer
          url="https://jtools.ro/img/map/{z}/{x}/{y}.png"
        />
        <DraggableMarker
          handleApplyMapCoordinates={handleApplyMapCoordinates}
        />
      </MapContainer>
  );
}

export default CoordinatesMap;
